import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';
import DIMENSIONS from '../../library/dimensions';
import { sidebarCollapseSpeed } from '../sidebar/sidebar-styles';

const styles = StyleSheet.create({
  root: {
    height: DIMENSIONS.headerHeight,
    background: COLORS.kgGreen,
    position: 'fixed',
    width: `calc(100% - ${DIMENSIONS.sidebarWidth}px)`,
    top: 0,
    left: DIMENSIONS.sidebarWidth,
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0 1px 8px rgba(0,0,0,0.04)',
    zIndex: 1,
    transition: sidebarCollapseSpeed
  },
  rootSidebarCollapsed: {
    width: `calc(100% - ${DIMENSIONS.sidebarWidthCollapsed}px)`,
    left: DIMENSIONS.sidebarWidthCollapsed,
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: DIMENSIONS.headerHeight,
    maxWidth: DIMENSIONS.contentWidth,
    margin: '0 auto'
  },
  currentFeatureTitle: {
    fontSize: 18,
    // color: 'white'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/layout/header-styles.js